import { createSlice } from '@reduxjs/toolkit';

const lessonDataSlice = createSlice({
  name: 'lessonData',
  initialState: {
    data: [],
    lessonProgress: [],
    files: {},
    videoHistory: null,
    homework: null,
    coevaluationsItems: null,
    coevaluationsHomeWork: null,
    homeworksList: null,
    quizData: null,
    quizEvaluableData: null,
    commentsForum: null,
    notes: null
  },
  reducers: {
    info(state, action) {
      state.data = action.payload.lessonData;
    },
    lessonProgress(state, action) {
      state.lessonProgress = action.payload.statusLessonData;
    },
    files(state, action) {
      state.files = action.payload.files;
    },
    videoHistory(state, action) {
      state.videoHistory = action.payload.videoHistory;
    },
    homework(state, action) {
      state.homework = action.payload.homework;
    },
    coevaluationsItems(state, action) {
      state.coevaluationsItems = action.payload.coevaluationsItems;
    },
    coevaluationsHomeWork(state, action) {
      state.coevaluationsHomeWork =
        action.payload.coevaluationsHomeWork;
    },
    homeworksList(state, action) {
      state.homeworksList = action.payload.homeworksList;
    },
    quizData(state, action) {
      state.quizData = action.payload.quizData;
    },
    quizEvaluableData(state, action) {
      state.quizEvaluableData = action.payload.quizEvaluableData;
    },
    commentsForum(state, action) {
      state.commentsForum = action.payload.commentsForum;
    },
    notes(state, action) {
      state.notes = action.payload.notes;
    }
  }
});

export const lessonDataActions = lessonDataSlice.actions;

export default lessonDataSlice;
